import checkDiscussionForErrors from "~/store/manage/validation/checkDiscussionForErrors";

const VALIDATE_DISCUSSION = (state) => {
  state.discussionErrors = checkDiscussionForErrors(state);
};

export default VALIDATE_DISCUSSION;
